import { useLocation } from 'react-router-dom';

const GUIDE_NAV_ITEMS = [
  {
    id: 'getting-married',
    label: 'Getting Married',
    to: '/getting-married-in-gibraltar',
    activePathname: '/getting-married-in-gibraltar',
  },
  {
    id: 'how-to-get-married',
    label: 'How to Get Married',
    to: '/how-to-get-married-in-gibraltar',
    activePathname: '/how-to-get-married-in-gibraltar',
  },
  {
    id: 'cost-of-getting-married',
    label: 'Cost of Getting Married',
    to: '/cost-of-getting-married-in-gibraltar',
    activePathname: '/cost-of-getting-married-in-gibraltar',
  },
  {
    id: 'churches-venues',
    label: 'Churches & Venues',
    to: '/wedding-venues-gibraltar',
    activePathname: '/wedding-venues-gibraltar',
  },
  {
    id: 'civil-registry',
    label: 'Civil & Registry',
    to: '/civil-registry-weddings-gibraltar',
    activePathname: '/civil-registry-weddings-gibraltar',
  },
  {
    id: 'wedding-planners',
    label: 'Wedding Planners',
    to: '/wedding-planners-gibraltar',
    activePathname: '/wedding-planners-gibraltar',
  },
];

export const GuideTopNavigation = ({ testIdPrefix = 'guide-top-nav', items = null }) => {
  const location = useLocation();
  const navItems = Array.isArray(items) && items.length > 0 ? items : GUIDE_NAV_ITEMS;

  const normalizePathname = (value) => {
    const normalized = String(value || '').replace(/\/+$/, '');
    return normalized || '/';
  };

  return (
    <nav className="grid grid-cols-1 gap-3 md:grid-cols-2" data-testid={`${testIdPrefix}-container`}>
      {navItems.map((item) => {
        const activePath = item.activePathname || null;
        const isActive = Boolean(activePath && normalizePathname(location.pathname) === normalizePathname(activePath));

        return (
          <a
            key={item.id}
            href={item.to}
            className={`inline-flex min-h-[48px] items-center justify-center rounded-xl border px-4 py-3 text-sm font-semibold transition ${
              isActive
                ? 'border-[#D4AF37] bg-[#4A001A] text-white ring-2 ring-[#D4AF37]/40'
                : 'border-[#5C0120] bg-[#5C0120] text-white hover:bg-[#D4AF37] hover:border-[#D4AF37]'
            }`}
            aria-current={isActive ? 'page' : undefined}
            data-testid={`${testIdPrefix}-button-${item.id}`}
          >
            {item.label}
          </a>
        );
      })}
    </nav>
  );
};
